import { render, staticRenderFns } from "./CustomFormChange.vue?vue&type=template&id=5bed2c74&scoped=true&"
import script from "./CustomFormChange.vue?vue&type=script&lang=js&"
export * from "./CustomFormChange.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bed2c74",
  null
  
)

export default component.exports